


jQuery_T4NT(document).ready(function($) {

  /* -------------------------
     原本商品折叠逻辑（不动）
  -------------------------- */
  const titles = document.querySelectorAll(".t4s-pr__fold .fold-title");
  if (titles && titles.length > 0) {
    // 默认展开第一个
    titles[0].setAttribute('index', 1);
    titles[0].querySelector(".fold-arrow").style.transform = "translate(-50%, -50%) rotate(180deg)";
    titles[0].nextElementSibling.style.height = titles[0].nextElementSibling.scrollHeight + 'px';

    titles.forEach((title) => {
      title.setAttribute('index', 0);
      title.addEventListener('click', function() {
        if (this.getAttribute('index') == 0) {
          this.nextElementSibling.style.height = this.nextElementSibling.scrollHeight + 'px';
          this.querySelector(".fold-arrow").style.transform = "translate(-50%, -50%) rotate(180deg)";
          this.setAttribute('index', 1);
        } else {
          this.nextElementSibling.style.height = "0px";
          this.querySelector(".fold-arrow").style.transform = "translate(-50%, -50%) rotate(0deg)";
          this.setAttribute('index', 0);
        }
      });
    });
  }


  /* -------------------------
     Show More / Show Less 控制逻辑
     只控制第一项的 fold-content
  -------------------------- */
  const firstFold = document.querySelector(".t4s-pr__fold .fold-content");
  const toggleBtn = document.querySelector(".fold-toggle-btn");

  if (firstFold && toggleBtn) {
    // 默认高度 260px（你的需求）
    const collapsedHeight = 260;
    let expanded = false;

    // 初始状态固定高度
    firstFold.style.height = collapsedHeight + "px";

    // 强制按钮显示（防止主题 CSS 再隐藏）
    toggleBtn.style.display = "block";

    // 按钮点击事件
    toggleBtn.addEventListener("click", function () {
      expanded = !expanded;

      if (!expanded) {
        // 折叠 — 设置 260px
        firstFold.style.height = collapsedHeight + "px";
        toggleBtn.textContent = "Show More";
      } else {
        // 展开 — 自适应高度
        firstFold.style.height = firstFold.scrollHeight + "px";
        toggleBtn.textContent = "Show Less";
      }
    });

    // 每次图片加载后更新 scrollHeight
    window.addEventListener("load", () => {
      if (expanded) {
        firstFold.style.height = firstFold.scrollHeight + "px";
      }
    });
  }

});






const observer = new MutationObserver(() => {
  const el = document.querySelector('#shopify-chat > :first-child');

  if (el) {
    el.style.setProperty('z-index', '99', 'important');
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});